module.exports = __webpack_public_path__ + "static/assets/9a7bbbbebc4b2b303d426f8a7f963298.gif";